var _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClockTiny = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 6,
  stroke: "currentColor",
  strokeWidth: 1.75
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 8,
  x2: 8,
  y2: 5,
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 8,
  y1: 8,
  x2: 10,
  y2: 10,
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round"
})));
export default SvgClockTiny;